import { render, staticRenderFns } from "./InstanceAdd.vue?vue&type=template&id=872d8fda&"
import script from "./InstanceAdd.vue?vue&type=script&lang=ts&"
export * from "./InstanceAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports